<template>
  <a-layout>
    <a-card :bordered='false'>
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      <span class="ml15 card_title">{{$route.query.type == 'add' ? '创建':'编辑'}}扫码活动</span>
    </a-card>
    <a-card :bordered="false">
      <a-steps v-model:current="current" type="navigation" size="small" :style="{
            marginBottom: '20px',
            boxShadow: '0px -1px 0 0 #e8e8e8 inset',
          }">
        <a-step :status="current==0?'process':'wait'" :disabled="$route.query.type!='edit'" :title="$route.query.type=='add'?'创建活动':'编辑活动'" />
        <a-step :status="current==1?'process':'wait'" :disabled="$route.query.type!='edit'" title="设置二维码范围" />
        <a-step :status="current==2?'process':'wait'" :disabled="$route.query.type!='edit'" title="设置活动奖项" />
      </a-steps>
      <div class="content" v-show="current == 0">
        <setpsOne ref="one" v-on:setpsOneDone="setpsOneDone" :activity_id="$route.query.activity_id||activity_id" v-on:template_type="tempalteTypeChange" :actionType='$route.query.type' :isAction="isAction"  />
      </div>
      <div class="content" v-if="current == 1">
        <setpsTwo ref="two" :activity_id="activity_id" v-on:setpsTwoProvide="setpsTwoProvide" v-on:setpsTwoNext="setpsTwoNext" :actionType='$route.query.type' />
      </div>
        <div class="content" v-if="current == 2">
        <setpsThree ref="three" :activity_id="activity_id" v-on:setpsThreeProvide="setpsThreeProvide" v-on:setpsThreeNext="setpsThreeNext" :actionType='$route.query.type'/>
      </div>
    </a-card>
  </a-layout>
</template>
<script>
import { ref } from "@vue/reactivity";
import setpsOne from "./components/setpsOne/index";
import setpsTwo from "./components/setpsTwo/index";
import setpsThree from "./components/setpsThree/index";
import { inject, onMounted } from "@vue/runtime-core";
import { LeftOutlined} from "@ant-design/icons-vue";
export default {
  components: { setpsOne, setpsTwo,LeftOutlined,setpsThree },
  setup() {
    const $route = inject("$route");
    const current = ref(0);
    const activity_id=ref('')
      const two=ref()
    const three=ref()
    const isAction = ref(false)
    // 下一步
    const setpsOneDone = (data) => { 
      console.log(data);
      if ($route.query.activity_id) {
        activity_id.value=$route.query.activity_id
      }else if(data.activity_id){
         activity_id.value=data.activity_id
      }
      current.value++
      setpsTwoDetail();
      isAction.value=true;
    };
     // 第一步结束
    // 第二步开始
    var setpsTwoDetail=()=>{
      two.value && two.value.detail();
    }
     // 第二步 下一步
    const setpsTwoNext=()=>{
       current.value++;
    };
     // 上一步
    const setpsTreeProvide=()=>{
       current.value--;
       setpsTwoDetail()
    }
    // 获取详情
    const one = ref("");
    const setpsOneDetail = () => {
      one.value.detail();
    };
    const setpsTwoProvide=()=>{
      setpsOneDetail();
      current.value--
    };
     const setpsThreeProvide=()=>{
      setpsTwoDetail();
      current.value--
    };
    onMounted(() => {
      if ($route.query.activity_id) {
        activity_id.value=$route.query.activity_id
        setpsOneDetail();
      }
    });
    return {
      current,
      setpsOneDone,
      one,
      activity_id,
      setpsTwoProvide,
      setpsTwoNext,
      two,
      three,
      setpsTreeProvide,
      setpsThreeProvide,
      isAction
    };
  },
};
</script>